module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Bold.woff2?8a27ba32a0e025d5c56870ab8bd51590";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Bold.woff2
// module id = 1424
// module chunks = 0